<div class="containerTarif sub-container">
  <div class="txtAction">
    <ng-template #isSelectedFormulaTmp>
      <div class="select-text">
        <mat-icon>check</mat-icon>formulaire sélectionnée
      </div>
    </ng-template>
  </div>
  <wz-filtre-offres-b2c
    (filtrePrixEvent)="receipFiltrePrix($event)"
    (inFosPersonneEvent)="receiveInfosPersonne($event)"
    (filtreNiveauEvent)="receipFiltreNiveau($event)"
    [nombreFormules]="formulesAfi[0]?.tarifs?.length?.toString() ?? ''"
    [textNombreFormule]="textNombreFormule"
  >
  </wz-filtre-offres-b2c>

  <!-- <div style="width: 100%; text-align: center; ">
  <mat-progress-spinner *ngIf="isLoadingMetas" mode="indeterminate" [diameter]="100" [strokeWidth]="2" color="accent"
    class="spinner-3">
  </mat-progress-spinner>
</div> -->

  <div
    *ngIf="isLoadingMetas"
    style="
      background: rgb(0, 0, 0);
      position: absolute;
      width: 100vw;
      overflow: hidden;
      height: 100vh;
      z-index: 100;
      opacity: 0;
      top: 0;
      left: 0;
    "
  ></div>

  <div class="pricings" style="position: relative">
    <!-- <div *ngIf="isLoadingMetas" class="loading">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div> -->

    <!-- <mat-progress-spinner *ngIf="isLoadingMetas" mode="indeterminate" [diameter]="500" [strokeWidth]="2" color="accent"
    class="spinner-3">
  </mat-progress-spinner> -->

    <div
      *ngIf="isLoadingMetas"
      class="loaderContainer"
      style="
        background: rgb(0, 0, 0, 0.5);
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 100;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <!-- <button class="btn btn-success" (click)="showSpinner()">Show spinner</button> -->

      <mat-progress-spinner
        mode="indeterminate"
        [diameter]="100"
        [strokeWidth]="5"
        color="accent"
        style="margin: 15% auto"
        class="spinner-3 loaderContent"
      >
      </mat-progress-spinner>
    </div>

    <!-- <app-spinner [show]="show" [size]="150"></app-spinner> -->

    <div class="divOffre" *ngFor="let p of formulesAfi; let i = index">
      <!-- <div style="width: 100%;padding-right: 2%; margin-bottom: -2%; text-align: right;">
      {{ p.tarifs.length }} formules
    </div> -->

      <div *ngFor="let f of p.tarifs; let index = index" class="offreBloc">
        {{ integreTextGarenties(f.produitTarif, f.codeFormule) }}
        <div class="promo-parent">
          <!-- <div *ngIf=" (f.produitTarif == 'ESS_SANTE_SENIOR' || f.produitTarif =='ESS_SANTE_FAMILLE' ) && f.codeFormule != 'Formule 1' " class="promotion"> -->
          <!-- <div *ngIf="f.produitTarif == 'CEGEMAV'" class="promotion">
                    <div>
                        <span> PROMO </span>: tarif garanti jusqu’au 1er janvier 2025 !
                    </div>
                    <div class="infobulle">
                        <img src="assets/img/infoicon.svg" width="12px"  alt=""/>
                        <span class="infobulletext">
                            <p> Offre valable pour tous les nouveaux contrats de la gamme Essentiel Santé Famille ou
                                Sénior souscrits avant le <b> 31 Janvier 2023 </b>, pour les formules de niveau 2 à 6.
                            </p>
                            <p>
                                Le bénéfice de cette offre est conditionné à la remise d’un certificat d’adhésion
                                mentionnant le maintien du tarif applicable à la date de souscription jusqu’à la fin de
                                la deuxième année d’adhésion (échéance principale de l’adhésion correspondant à la date
                                d’anniversaire du contrat), hors application de l’évolution de la cotisation liée à
                                l’âge et/ou aux évolutions réglementaires.
                            </p>
                            <p>
                                La réduction de cotisation afférente sera appliquée à compter des renouvellements de
                                votre adhésion et figureront sur vos avis d’échéance annuels.
                            </p>
                            <p>
                                La réduction de cotisation afférente ne pourra pas être appliquée en cas de modification
                                du contrat à l’échéance principale ou en cours d’année pour les raisons suivantes :
                            </p>
                            <ul>
                                <li> Changement de niveau de garanties,</li>
                                <li> Ajout ou sortie de bénéficiaire,</li>
                                <li> Changement de domicile entrainant un changement de zone tarifaire</li>
                                <li>Changement du Régime Obligatoire d’un des assurés</li>
                            </ul>
                        </span>
                    </div>
                </div> -->
          <div
            *ngIf="
              (f.produitTarif == 'ESS_SANTE_SENIOR' ||
                f.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR' ||
                f.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR_ECO' ||
                f.produitTarif == 'RELAXEO2') &&
              !['F1', 'Formule 1'].includes(f.codeFormule!) &&
              verifyDateBetween('2023-10-01', '2023-11-30') &&
              IsAgePlus55()
            "
            class="promotion"
          >
            <div><span> PROMO </span>: 1 MOIS OFFERT !</div>
            <div class="infobulle visible">
              <img
                src="assets/img/infoicon.svg"
                width="12px"
                (click)="handleToggleInfoBulle($event)"
              />
              <span class="infobulletext">
                <p>
                  Offre valable pour tous les nouveaux contrats de la gamme
                  {{ formatProductName(f.produitTarif) }} souscrits avant le 30
                  novembre 2023, à l'exclusion de la formule 1. <br />Votre 2ème
                  mois de cotisation, vous sera intégralement remboursé sous
                  réserve du paiement complet des 2 premières mensualités de
                  votre contrat.
                </p>
                <p>
                  Le remboursement de votre mois offert interviendra dans le
                  courant du 3e mois suivant la prise d’effet de votre contrat.
                </p>
              </span>
            </div>
          </div>
          <!-- PROMO SPVIE SANTE_MALIN-->
          <div
            *ngIf="
              f.produitTarif == 'SANTE_MALIN' &&
              verifyDateBetween('2024-2-01', '2024-03-28')
            "
            class="promotion"
          >
            <div><span> PROMO </span>: 1 MOIS OFFERT !</div>
            <div class="infobulle visible">
              <img
                src="assets/img/infoicon.svg"
                width="12px"
                (click)="handleToggleInfoBulle($event)"
              />
              <span class="infobulletext">
                <p>
                  En ce moment bénéficiez d’1 mois offert en souscrivant avant
                  le 31 mars !
                </p>
                13ème mois d’adhésion offert en souscrivant avant le 31 mars
                2024.
              </span>
            </div>
          </div>
          <div *ngIf="f.isNonResponsable" class="promotion">
            <div>
              <span> Non Responsable </span>
            </div>
            <div class="infobulle visible">
              <img
                src="assets/img/infoicon.svg"
                width="12px"
                (click)="handleToggleInfoBulle($event)"
              />
              <span class="infobulletext">
                <p>
                  Contrat Non Responsable : le 100% Santé n'est pas pris en
                  charge intégralement
                </p>
              </span>
            </div>
          </div>
        </div>
        <div
          data-class="label_excellence"
          *ngIf="
            f.produitTarif == 'MEILLEURTAUX_VITA_SANTE_55_PLUS_ECO_NR' ||
            f.produitTarif == 'MEILLEURTAUX_VITA_SANTE_55_PLUS_NR' ||
            f.produitTarif == 'AESIO_IMM_SANTE_SENIOR' ||
            f.produitTarif == 'AESIO_IMM_SANTE_SENIOR_ECO' ||
            f.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR' ||
            f.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR_ECO'
          "
        >
          <img src="assets/img/label_excellence.svg" alt="Image Excellence" />
        </div>
        <!-- NOUVEAU PROGRESSION SANTE -->
        <!-- <picto-infos [typePicto]="typePicto.Nouveau" *ngIf="f.produitTarif=='PROGR_SANTE_FAMILLE'">
                </picto-infos> -->

        <!-- ENCART PROMO PROGRESSION SANTE SENIOR IMM SANTE SENIOR PREVOIR IMM SANTE SENIOR AESIO -->

        <!-- <picto-infos [typePicto]="typePicto.Promo" [nomProduit]="f.produitTarif" *ngIf="(
                  f.produitTarif =='PROGR_SANTE_SENIOR' ||
                  f.produitTarif=='PREVOIR_IMM_SANTE_SENIOR' ||
                  f.produitTarif=='PREVOIR_IMM_SANTE_SENIOR_ECO' ||
                  f.produitTarif=='AESIO_IMM_SANTE_SENIOR_ECO') && (f.codeFormule != 'Formule 1')" >
                </picto-infos> -->
        <div class="offre">
          <div class="divLogo">
            <img
              src="assets/img/kereis-solutions.svg"
              alt=""
              *ngIf="
                f.produitTarif == 'CEGEMAV' ||
                f.produitTarif == 'CEGE_EQUILIBRE'
              "
            />
            <img
              src="assets/img/kereis-solutions.svg"
              alt=""
              *ngIf="
                f.produitTarif == 'CEGEMA_FLEXI_SANTE_NON_RESPONSABLE' ||
                f.produitTarif == 'CEGEMA_FLEXI_SANTE_RESPONSABLE'
              "
            />
            <img
              src="assets/img/kereis-solutions.svg"
              alt=""
              *ngIf="f.produitTarif == 'KEREIS_SERENITE'"
            />
            <img
              src="assets/img/kereis-solutions.svg"
              alt=""
              *ngIf="f.produitTarif == 'CEGEMAEss'"
            />
            <img
              src="assets/img/apivia.svg"
              alt=""
              *ngIf="f.produitTarif == 'VITAMIN3'"
            />
            <img
              src="assets/img/Swiss.png"
              alt=""
              *ngIf="f.produitTarif == 'SWLF_RETRAITES'"
            />
            <img
              src="assets/img/Swiss.png"
              alt=""
              *ngIf="f.produitTarif == 'PARTICULIER'"
            />
            <img
              src="assets/img/Logo_MTX.svg"
              alt=""
              *ngIf="afficherLogoMTX(f.produitTarif!)"
            />
            <img
              src="../../../../../../assets/img/zenioo.svg"
              alt=""
              *ngIf="afficherLogoZNIOO(f.produitTarif!)"
            />
            <img
              src="../../../../../../assets/img/spvie-logo.svg"
              alt=""
              *ngIf="
                f.produitTarif == 'SPVIE_SANTE_NOVA_NR' ||
                f.produitTarif == 'SANTE_MALIN' ||
                f.produitTarif == 'SPVIE_GENIUS_ESSENTIELLE'
              "
            />
          </div>
          <div class="divPrix">
            <div class="formuleNom">
              <div id="formule" class="form3">
                <p
                  *ngIf="
                    f.isMarqueBlanche! &&
                    verifyDateBetween('2025-06-01', '2025-06-30')
                  "
                  class="FraisOffert"
                >
                  Frais de dossier offert jusqu'au 30 juin inclus !
                </p>
                <p class="tFormule">
                  {{ replaceFormule(f.codeFormule!, f.produitTarif!) }}
                  <span *ngIf="ecoSuffixTarifs.includes(f.produitTarif!)"
                    >ECO</span
                  >
                </p>
                <div
                  *ngIf="
                    f.produitTarif == 'MEILLEURTAUX_VITA_SANTE_55_PLUS_NR' ||
                    f.produitTarif == 'MEILLEURTAUX_VITA_SANTE_55_PLUS_ECO_NR'
                  "
                  class="imgFormule"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/mtx_vita_sante_plus55.svg"
                    alt=""
                  />
                </div>
                <div
                  *ngIf="
                    f.produitTarif ==
                      'MEILLEURTAUX_VITA_SANTE_FAMILLE_ECO_NR' ||
                    f.produitTarif == 'MEILLEURTAUX_VITA_SANTE_FAMILLE_NR'
                  "
                  class="imgFormule"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/mtx_vita_sante_famille.svg"
                    alt=""
                  />
                </div>
                <div
                  *ngIf="
                    f.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE_ECO' ||
                    f.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE'
                  "
                  class="imgFormule"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/100FamilleSante.svg"
                    alt=""
                  />
                </div>

                <div
                  *ngIf="
                    f.produitTarif == 'AESIO_IMM_SANTE_FAMILLE_ECO' ||
                    f.produitTarif == 'AESIO_IMM_SANTE_FAMILLE'
                  "
                  class="imgFormule"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/100FamilleSante.svg"
                    alt=""
                  />
                </div>

                <div
                  *ngIf="f.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR_ECO'"
                  class="imgFormule"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/aesio_imm_senior_eco.svg"
                    alt=""
                  />
                </div>

                <div
                  *ngIf="f.produitTarif == 'AESIO_IMM_SANTE_SENIOR_ECO'"
                  class="imgFormule"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/aesio_imm_senior_eco.svg"
                    alt=""
                  />
                </div>

                <div
                  *ngIf="f.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR'"
                  class="imgFormule"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/aesio_imm_senior.svg"
                    alt=""
                  />
                </div>

                <div
                  *ngIf="f.produitTarif == 'AESIO_IMM_SANTE_SENIOR'"
                  class="imgFormule"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/aesio_imm_senior.svg"
                    alt=""
                  />
                </div>

                <div class="imgFormule" *ngIf="f.produitTarif == 'RELAXEO2'">
                  <img class="scaleImg" src="assets/img/Relaxeo.svg" alt="" />
                </div>

                <div
                  class="imgFormule"
                  *ngIf="f.produitTarif == 'ESS_SANTE_SENIOR'"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/Essentiel_Sante_Senior.svg"
                    alt=""
                  />
                </div>
                <div
                  class="imgFormule"
                  *ngIf="f.produitTarif == 'ESS_SANTE_FAMILLE'"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/Essentiel_Sante_Famille.svg"
                    alt=""
                  />
                </div>

                <div
                  class="imgFormule"
                  *ngIf="f.produitTarif == 'PROGR_SANTE_SENIOR'"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/prog_sante_senior.svg"
                    alt=""
                  />
                </div>
                <div
                  class="imgFormule"
                  *ngIf="f.produitTarif == 'PROGR_SANTE_FAMILLE'"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/prog_sante_famille.svg"
                    alt=""
                  />
                </div>
                <div
                  class="imgFormule"
                  *ngIf="
                    f.produitTarif == 'Apivia' || f.produitTarif == 'VITAMIN3'
                  "
                >
                  <img class="scaleImg" src="assets/img/Vitamin3.svg" alt="" />
                </div>
                <div class="imgFormule" *ngIf="f.produitTarif == 'PARTICULIER'">
                  <img class="scaleImg" src="assets/img/SLPart.svg" alt="" />
                </div>
                <div
                  class="imgFormule"
                  *ngIf="f.produitTarif == 'SWLF_RETRAITES'"
                >
                  <img class="scaleImg" src="assets/img/SLSenior.svg" alt="" />
                </div>

                <div class="imgFormule" *ngIf="f.produitTarif == 'CEGEMAV'">
                  <img class="scaleImg" src="assets/img/vitaneor.svg" alt="" />
                </div>
                <div
                  class="imgFormule"
                  *ngIf="f.produitTarif == 'CEGE_EQUILIBRE'"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/cegema-equilibre.svg"
                    alt=""
                  />
                </div>
                <div
                  class="imgFormule"
                  *ngIf="
                    f.produitTarif == 'CEGEMA_FLEXI_SANTE_NON_RESPONSABLE' ||
                    f.produitTarif == 'CEGEMA_FLEXI_SANTE_RESPONSABLE'
                  "
                >
                  <img
                    class="scaleImg"
                    src="assets/img/cegema-flexibilite.svg"
                    alt=""
                  />
                </div>
                <div
                  class="imgFormule"
                  *ngIf="f.produitTarif == 'KEREIS_SERENITE'"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/cegema-serenite-sante.svg"
                    alt=""
                  />
                </div>
                <div class="imgFormule" *ngIf="f.produitTarif == 'CEGEMAEss'">
                  <img
                    class="scaleImg"
                    src="assets/img/essentiel2.svg"
                    alt=""
                  />
                </div>

                <div
                  class="imgFormule"
                  *ngIf="f.produitTarif == 'ZEN_SANTE_FAMILLE'"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/Zenioo_Sante_Famille.svg"
                    alt=""
                  />
                </div>
                <div
                  class="imgFormule"
                  *ngIf="f.produitTarif == 'ZEN_SANTE_55_PLUS'"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/Zenioo_Sante_55Plus.svg"
                    alt=""
                  />
                </div>
                <div
                  class="imgFormule"
                  *ngIf="f.produitTarif == 'ZEN_SANTE_SENIOR'"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/Zenioo_Sante_Senior.svg"
                    alt=""
                  />
                </div>
                <div
                  class="imgFormule"
                  *ngIf="f.produitTarif == 'ZEN_SANTE_SENIOR_ECO'"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/Zenioo_Sante_Senior_Eco.svg"
                    alt=""
                  />
                </div>
                <div
                  class="imgFormule"
                  *ngIf="f.produitTarif == 'AC_PRIVILEGE'"
                >
                  <img
                    class="scaleImg"
                    src="assets/img/OptimumSante.svg"
                    alt=""
                  />
                </div>
                <div class="imgFormule" *ngIf="f.produitTarif == 'SANTE_MALIN'">
                  <img
                    class="scaleImg"
                    src="../../../../../../assets/img/spvie_sante_malin.svg"
                    alt=""
                  />
                </div>
                <div
                  class="imgFormule"
                  *ngIf="f.produitTarif == 'SPVIE_GENIUS_ESSENTIELLE'"
                >
                  <img
                    class="scaleImg"
                    src="../../../../../../assets/img/spvie_sante_essentielle.svg"
                    alt=""
                  />
                </div>
                <div
                  class="imgFormule"
                  *ngIf="f.produitTarif == 'SPVIE_GENIUS_CONFORT'"
                >
                  <img
                    class="scaleImg"
                    src="../../../../../../assets/img/spvie_sante_confort.svg"
                    alt=""
                  />
                </div>
                <div
                  class="imgFormule"
                  *ngIf="f.produitTarif == 'SPVIE_SANTE_NOVA_NR'"
                >
                  <img
                    class="scaleImg"
                    src="../../../../../../assets/img/spvie_sante_nova_nr.svg"
                    alt=""
                  />
                </div>
                <div id="prixFormule">
                  <div class="mensuel">
                    <p>
                      <span class="prix">{{
                        (ate(f.montant) | number: '1.1-2')?.split('.')?.[0] ??
                          '0'
                      }}</span>
                      <span class="prixCentimes"
                        >,{{
                          (ate(f.montant) | number: '1.1-2')?.split('.')?.[1] ??
                            '00'
                        }}</span
                      >
                      <span class="prix">€</span>/mois
                    </p>
                    <!-- <p>
                      <span class="prix">{{ (ate(f.montant) | number: '1.1-2')?.split('.')?.[0] ?? '0' }}€</span>
                      /mois

                    </p> -->
                    <!-- <p>
                      <span class="prix">{{ ate(f.montant) }}€</span>
                      /mois
                    </p> -->
                  </div>
                  <div class="annuel">
                    Soit {{ ate(f.montant) * 12 | number: '1.1-2' : 'fr' }}€/an
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="divSpec">
            <div class="spec">
              <div class="labelSpec">Soins médicaux</div>
              <div class="scoreSpec">
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_soinsmedicaux!) >= 1,
                  }"
                ></div>
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_soinsmedicaux!) >= 2,
                  }"
                ></div>
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_soinsmedicaux!) >= 3,
                  }"
                ></div>
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_soinsmedicaux!) >= 4,
                  }"
                ></div>
              </div>
            </div>
            <div class="spec">
              <div class="labelSpec">Hospitalisation</div>
              <div class="scoreSpec">
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_hospitalisation!) >= 1,
                  }"
                ></div>
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_hospitalisation!) >= 2,
                  }"
                ></div>
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_hospitalisation!) >= 3,
                  }"
                ></div>
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_hospitalisation!) >= 4,
                  }"
                ></div>
              </div>
            </div>
            <div class="spec">
              <div class="labelSpec">Dentaire</div>
              <div class="scoreSpec">
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_dentaire!) >= 1,
                  }"
                ></div>
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_dentaire!) >= 2,
                  }"
                ></div>
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_dentaire!) >= 3,
                  }"
                ></div>
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_dentaire!) >= 4,
                  }"
                ></div>
              </div>
            </div>
            <div class="spec">
              <div class="labelSpec">Optique</div>
              <div class="scoreSpec">
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_optique!) >= 1,
                  }"
                ></div>
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_optique!) >= 2,
                  }"
                ></div>
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_optique!) >= 3,
                  }"
                ></div>
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_optique!) >= 4,
                  }"
                ></div>
              </div>
            </div>
            <div class="spec">
              <div class="labelSpec">Aides auditives</div>
              <div class="scoreSpec">
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_auditives!) >= 1,
                  }"
                ></div>
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_auditives!) >= 2,
                  }"
                ></div>
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_auditives!) >= 3,
                  }"
                ></div>
                <div
                  class="score"
                  [ngClass]="{
                    scoreActive: getBullesNiveau(f.niv_auditives!) >= 4,
                  }"
                ></div>
              </div>
            </div>
          </div>

          <div
            class="divAction"
            [class.selected]="currentFormulaWithGroup.produit === p"
          >
            <button
              [disabled]="readonly"
              class="devisAction"
              id="devisBtn"
              *ngIf="
                !IsNoDisplayButton(f.produitTarif!) &&
                  formulasWithGroup !== currentFormulaWithGroup;
                else templateDisplay ? null : isSelectedFormulaTmp
              "
              (click)="
                openDialogDemanderDevis(p, f, index);
                tagDevis(p, f, index, 'demander un devis')
              "
            >
              <!-- <button class="devisAction" id="devisBtn" (click)="submitFormulaPicker(currentFormulaWithGroup)"> -->
              <div class="imgAction">
                <img src="assets/img/devis.svg" alt="" />
              </div>
              <div class="txtAction">Demander un devis</div>
            </button>
            <button
              class="souscriptionAction"
              (click)="
                tagSouscription(p, f, index, 'souscrire en ligne');
                selectProduitAfi(p, f, index);
                getDocLink(index)
              "
              *ngIf="produitsAutorisesTous.includes(f.produitTarif!)"
              [ngClass]="{ devisAction: IsButtonOrange(f.produitTarif!) }"
            >
              <div class="imgAction">
                <img [src]="pathImg" alt="" />
              </div>
              <div class="txtAction">Souscrire en ligne</div>
            </button>

            <!-- <button class="callAction" id="recallBtn" (click)="openEtreRappeleDialog(p, f)">
            <div class="imgAction">
              <img src="assets/img/call.svg" alt="" />
            </div>
            <div class="txtAction">
              Être rappelé
            </div>
          </button> -->

            <button
              class="call-appointment"
              *ngIf="!IsNoDisplayButton(f.produitTarif!)"
            >
              <div class="imgAction">
                <img src="assets/img/phone-appointment.svg" alt="" />
                <a
                  href="https://calendly.com/conseiller_mtxsante/rdv_commercial"
                  target="_blank"
                  rel="noopener"
                  >Prendre rendez-vous</a
                >
              </div>
            </button>
            <!-- modal etre appele-->
            <!--Dans etre rappele dialog-->
          </div>
          <span
            class="plusDetails"
            [attr.id]="'plusDetails-' + i + '-' + index"
            (click)="displayDetails(i, index)"
          >
            <img src="assets/img/arrow-down-alt.svg" alt="" />
            Plus de détails
          </span>
          <span
            class="moinsDetails"
            (click)="displayDetails(i, index)"
            [attr.id]="'moinsDetails-' + i + '-' + index"
          >
            <img src="assets/img/arrow-up-alt.svg" alt="" />
            Moins de détails
          </span>
        </div>
        <div
          class="offreDetails"
          [attr.id]="'accordion-body-' + i + '-' + index"
          [attr.aria-labelledby]="'accordion-header-' + i + '-' + index"
        >
          <div class="detailsContainer">
            <div class="detailSpec">
              <button class="accordion" (click)="displayAccordion($event)">
                <span>
                  <span class="labelAccordion"> Soins médicaux </span>
                  <div class="scoreAccordion">
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive: getBullesNiveau(f.niv_soinsmedicaux!) >= 1,
                      }"
                    ></div>
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive: getBullesNiveau(f.niv_soinsmedicaux!) >= 2,
                      }"
                    ></div>
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive: getBullesNiveau(f.niv_soinsmedicaux!) >= 3,
                      }"
                    ></div>
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive: getBullesNiveau(f.niv_soinsmedicaux!) >= 4,
                      }"
                    ></div>
                  </div>
                </span>
              </button>
              <div class="panel">
                <table
                  class="panelTable"
                  [innerHTML]="soinsMedicaux | safeHtml"
                ></table>
              </div>

              <button class="accordion" (click)="displayAccordion($event)">
                <span>
                  <span class="labelAccordion"> Hospitalisation </span>
                  <div class="scoreAccordion">
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive:
                          getBullesNiveau(f.niv_hospitalisation!) >= 1,
                      }"
                    ></div>
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive:
                          getBullesNiveau(f.niv_hospitalisation!) >= 2,
                      }"
                    ></div>
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive:
                          getBullesNiveau(f.niv_hospitalisation!) >= 3,
                      }"
                    ></div>
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive:
                          getBullesNiveau(f.niv_hospitalisation!) >= 4,
                      }"
                    ></div>
                  </div>
                </span>
              </button>
              <div class="panel">
                <table
                  class="panelTable block-of-text"
                  [innerHTML]="hospitalisation | safeHtml"
                ></table>
              </div>
              <button class="accordion" (click)="displayAccordion($event)">
                <span>
                  <span class="labelAccordion"> Dentaire </span>
                  <div class="scoreAccordion">
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive: getBullesNiveau(f.niv_dentaire!) >= 1,
                      }"
                    ></div>
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive: getBullesNiveau(f.niv_dentaire!) >= 2,
                      }"
                    ></div>
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive: getBullesNiveau(f.niv_dentaire!) >= 3,
                      }"
                    ></div>
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive: getBullesNiveau(f.niv_dentaire!) >= 4,
                      }"
                    ></div>
                  </div>
                </span>
              </button>
              <div class="panel">
                <table
                  class="panelTable"
                  [innerHTML]="dentaire | safeHtml"
                ></table>
              </div>

              <button class="accordion" (click)="displayAccordion($event)">
                <span>
                  <span class="labelAccordion"> Optique </span>
                  <div class="scoreAccordion">
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive: getBullesNiveau(f.niv_optique!) >= 1,
                      }"
                    ></div>
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive: getBullesNiveau(f.niv_optique!) >= 2,
                      }"
                    ></div>
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive: getBullesNiveau(f.niv_optique!) >= 3,
                      }"
                    ></div>
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive: getBullesNiveau(f.niv_optique!) >= 4,
                      }"
                    ></div>
                  </div>
                </span>
              </button>
              <div class="panel">
                <table
                  class="panelTable block-of-text"
                  [innerHTML]="optique | safeHtml"
                ></table>
              </div>
              <button class="accordion" (click)="displayAccordion($event)">
                <span>
                  <span class="labelAccordion"> Aides auditives </span>
                  <div class="scoreAccordion">
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive: getBullesNiveau(f.niv_auditives!) >= 1,
                      }"
                    ></div>
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive: getBullesNiveau(f.niv_auditives!) >= 2,
                      }"
                    ></div>
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive: getBullesNiveau(f.niv_auditives!) >= 3,
                      }"
                    ></div>
                    <div
                      class="score"
                      [ngClass]="{
                        scoreActive: getBullesNiveau(f.niv_auditives!) >= 4,
                      }"
                    ></div>
                  </div>
                </span>
              </button>
              <div class="panel">
                <table
                  class="panelTable"
                  [innerHTML]="auditif | safeHtml"
                ></table>
              </div>
            </div>
            <div class="aboutInfo">
              <br />
              <div class="avantageBloc">
                <h4>Les points forts :</h4>
                <div
                  class="listePointsFort"
                  [innerHTML]="pointForTypeProduit | safeHtml"
                ></div>
              </div>
              <br />
              <div class="docBloc">
                <h4>Documents à télécharger</h4>
                <p class="liendoc">
                  <a
                    id="CG"
                    class="CG"
                    href="{{ pathCGProduct }}"
                    target="_blank"
                    >Conditions générales
                    <img src="assets/img/download.svg" alt=""
                  /></a>
                  <a
                    id="FIP"
                    class="FIP"
                    href="{{ pathFidProduct }}"
                    target="_blank"
                    >Fiche d’information produit<img
                      src="assets/img/download.svg"
                      alt=""
                  /></a>
                  <a
                    id="TG"
                    class="TG"
                    href="{{ pathTabProduct }}"
                    target="_blank"
                    >Tableau de garantie<img
                      src="assets/img/download.svg"
                      alt=""
                  /></a>
                </p>
              </div>

              <br />
              <div class="docTarif">
                <table>
                  <tr class="tarifMensuel">
                    <td class="tarifLabel">Tarif mensuel</td>
                    <td class="tarifPrix">
                      {{ ate(f.montant) | number: '1.1-2' }} €
                    </td>
                  </tr>
                  <tr class="tarifAnnuel">
                    <td class="tarifLabel">Tarif annuel</td>
                    <td class="tarifPrix">
                      {{ ate(f.montant) * 12 | number: '1.1-2' : 'fr' }}€
                    </td>
                  </tr>

                  <tr
                    class="fraisDossier"
                    *ngIf="
                      f.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE_ECO' ||
                      f.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE' ||
                      f.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR_ECO' ||
                      f.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR' ||
                      f.produitTarif == 'AESIO_IMM_SANTE_FAMILLE_ECO' ||
                      f.produitTarif == 'AESIO_IMM_SANTE_FAMILLE' ||
                      f.produitTarif == 'AESIO_IMM_SANTE_SENIOR_ECO' ||
                      f.produitTarif == 'AESIO_IMM_SANTE_SENIOR' ||
                      f.produitTarif == 'PROGR_SANTE_SENIOR' ||
                      f.produitTarif == 'PROGR_SANTE_FAMILLE' ||
                      f.produitTarif == 'RELAXEO2' ||
                      f.produitTarif == 'ESS_SANTE_FAMILLE' ||
                      f.produitTarif == 'AC_PRIVILEGE' ||
                      f.produitTarif == 'ESS_SANTE_SENIOR'
                    "
                  >
                    <td class="tarifLabel">
                      Frais de dossier pour l'adhesion :
                    </td>
                    <td class="tarifPrix">25€</td>
                  </tr>
                  <tr class="fraisDossier" *ngIf="f.produitTarif == 'CEGEMAV'">
                    <td class="tarifLabel">Frais de dossier :</td>
                    <td class="tarifPrix">13€ unique à l’adhésion</td>
                  </tr>
                  <tr class="fraisDossier" *ngIf="f.produitTarif == 'CEGEMAV'">
                    <!-- <td class="tarifLabel">Frais d’association :</td> -->
                    <!-- <td class="tarifPrix">7€ à l’adhésion</td> -->
                    <td class="tarifLabel">Frais de fractionnement :</td>
                    <td class="tarifPrix">1€/mois</td>
                  </tr>
                  <tr
                    class="fraisDossier"
                    *ngIf="f.produitTarif == 'CEGEMAEss'"
                  >
                    <td class="tarifLabel">Frais de dossier :</td>
                    <td class="tarifPrix">13€ unique à l’adhésion</td>
                  </tr>
                  <tr
                    class="fraisDossier"
                    *ngIf="f.produitTarif == 'CEGEMAEss'"
                  >
                    <!-- <td class="tarifLabel">Frais d’association inclus au tarif :</td> -->
                    <td class="tarifLabel">
                      Frais d'association et fractionnent inclus au tarif :
                    </td>
                    <td class="tarifPrix">1,58€/mois</td>
                  </tr>
                  <tr
                    class="fraisDossier"
                    *ngIf="
                      f.produitTarif == 'PARTICULIER' ||
                      f.produitTarif == 'SWLF_RETRAITES'
                    "
                  >
                    <td class="tarifLabel">Frais d'association :</td>
                    <td class="tarifPrix">7€ à l’adhésion</td>
                  </tr>
                  <tr
                    class="fraisDossier"
                    *ngIf="f.produitTarif == 'CEGE_EQUILIBRE'"
                  >
                    <td class="tarifLabel">Frais de dossier :</td>
                    <td class="tarifPrix">15€ unique à l’adhésion</td>
                  </tr>
                  <tr
                    class="fraisDossier"
                    *ngIf="
                      f.produitTarif == 'CEGEMA_FLEXI_SANTE_NON_RESPONSABLE' ||
                      f.produitTarif == 'CEGEMA_FLEXI_SANTE_RESPONSABLE'
                    "
                  >
                    <td class="tarifLabel">Frais de dossier :</td>
                    <td class="tarifPrix">15€ unique à l’adhésion</td>
                  </tr>
                  <tr
                    class="fraisDossier"
                    *ngIf="f.produitTarif == 'KEREIS_SERENITE'"
                  >
                    <td class="tarifLabel">
                      Frais de dossier pour l'adhesion :
                    </td>
                    <td class="tarifPrix">25€</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- mention legal---->
    <div class="container-m-legale">
      <!-- <div class="m-header-m-legale">
        Mention légale
      </div> -->
      <div class="m-legale">
        *En tant que courtier en assurance Meilleurtaux Santé classe les offres
        d’assurance par prix en fonction des besoins exprimées et ce, de manière
        totalement indépendante de toute rémunération de ses partenaires.
      </div>
    </div>
    <!--<mat-card
    class="full flex"
    *ngFor="let formulaWithGroup of formulasWithGroup"
    [class.selected]="currentFormulaWithGroup === formulaWithGroup"
  >
    <mat-card-content>
      <mat-expansion-panel [(expanded)]="expanded" class="expansion-panel no-shadow">
        <mat-expansion-panel-header class="header">
          {{ formulaWithGroup.formula.formula | wzI18nEnum: 'FORMULA_ENUM' }}
        </mat-expansion-panel-header>
        <div class="warranties" *ngIf="isAutoType; else santeTmp">
          <div *ngFor="let warr of formulaWithGroup.formula['warranties']" class="warranty">
            {{ warr.warranty | wzI18nEnum: 'WARRANTY_ENUM' }}
            <div class="franchise" *ngIf="warr.franchise">Franchise à {{ warr.franchise }}€</div>
          </div>
        </div>
        <ng-template #santeTmp>
          <div class="univers-besoins">
            <div
              *ngFor="let ub of formulaWithGroup.formula['universBesoinNotes']"
              class="ub"
              [class.highlighted]="
                ub.type == UniversBesoinTypeEnum.BienEtre || ub.type == UniversBesoinTypeEnum.AvantageCapitalDC
              "
              [class.selected]="currentFormulaWithGroup === formulaWithGroup"
            >
              <div class="content">
                <div class="type">{{ ub.type | wzI18nEnum: 'UNIVERS_BESOIN_TYPE_ENUM' }}</div>
                <div class="spacer"></div>
                <div
                  class="value"
                  *ngIf="
                    !universalNeedsWithImage[ub.type] ||
                      formulaWithGroup.formula.formula == FormulaEnum.Sante1 ||
                      currentFormulaWithGroup !== formulaWithGroup;
                    else imgNeedRef
                  "
                >
                  <div>{{ ub.value }}</div>
                  <div class="metric">{{ ub.metricType | universBesoinMetric }}</div>
                </div>
              </div>
            </div>

            <ng-template #imgNeedRef>
              <img src="assets/img/health100.png" height="30px" alt="" />
            </ng-template>

            <div
              *ngIf="package == PackageEnum.Sante_Fidelity"
              class="ub highlighted"
              [class.selected]="currentFormulaWithGroup === formulaWithGroup"
            >
              <div class="type">Bonus Fidélité dès la 2ème année</div>
            </div>
          </div>
        </ng-template>
      </mat-expansion-panel>
      <wz-pricing
        [staggering]="staggering"
        [isLoading]="isLoading || !currentFormulaWithGroup.formula.pricing"
        [selected]="currentFormulaWithGroup === formulaWithGroup"
        [pricing]="formulaWithGroup.formula.pricing"
      >
      </wz-pricing>
      <button
        type="button"
        [disabled]="readonly"
        *ngIf="formulaWithGroup !== currentFormulaWithGroup; else isSelectedFormulaTmp"
        class="select-this"
        mat-raised-button
        color="primary"
        (click)="selectFormula(formulaWithGroup)"
      >
        Choisir cette formule
      </button>
      <ng-template #isSelectedFormulaTmp>
        <div class="selected-text"><mat-icon>check</mat-icon>Formule sélectionnée</div>
      </ng-template>
    </mat-card-content>
  </mat-card>-->

    <!-- <div class="warranties">
    <div *ngFor="let f of listeReponseAfi[0].Tarifs]" class="warranty">
      {{ f.CodeFormule }}

    </div>
  </div> -->

    <!-- <div class="divOffre" *ngFor="let p of formulesAfi; let i = index">
    <div *ngFor="let f of p.tarifsTout; let index = index">
      {{ f.produitTarif + ' : ' + f.codeFormule }}
    </div>
  </div> -->
  </div>
  <!--<mat-card
    class="full flex"
    *ngFor="let formulaWithGroup of formulasWithGroup"
    [class.selected]="currentFormulaWithGroup === formulaWithGroup"
  >
    <mat-card-content>
      <mat-expansion-panel [(expanded)]="expanded" class="expansion-panel no-shadow">
        <mat-expansion-panel-header class="header">
          {{ formulaWithGroup.formula.formula | wzI18nEnum: 'FORMULA_ENUM' }}
        </mat-expansion-panel-header>
        <div class="warranties" *ngIf="isAutoType; else santeTmp">
          <div *ngFor="let warr of formulaWithGroup.formula['warranties']" class="warranty">
            {{ warr.warranty | wzI18nEnum: 'WARRANTY_ENUM' }}
            <div class="franchise" *ngIf="warr.franchise">Franchise à {{ warr.franchise }}€</div>
          </div>
        </div>
        <ng-template #santeTmp>
          <div class="univers-besoins">
            <div
              *ngFor="let ub of formulaWithGroup.formula['universBesoinNotes']"
              class="ub"
              [class.highlighted]="
                ub.type == UniversBesoinTypeEnum.BienEtre || ub.type == UniversBesoinTypeEnum.AvantageCapitalDC
              "
              [class.selected]="currentFormulaWithGroup === formulaWithGroup"
            >
              <div class="content">
                <div class="type">{{ ub.type | wzI18nEnum: 'UNIVERS_BESOIN_TYPE_ENUM' }}</div>
                <div class="spacer"></div>
                <div
                  class="value"
                  *ngIf="
                    !universalNeedsWithImage[ub.type] ||
                      formulaWithGroup.formula.formula == FormulaEnum.Sante1 ||
                      currentFormulaWithGroup !== formulaWithGroup;
                    else imgNeedRef
                  "
                >
                  <div>{{ ub.value }}</div>
                  <div class="metric">{{ ub.metricType | universBesoinMetric }}</div>
                </div>
              </div>
            </div>

            <ng-template #imgNeedRef>
              <img src="assets/img/health100.png" height="30px" alt=""/>
            </ng-template>

            <div
              *ngIf="package == PackageEnum.Sante_Fidelity"
              class="ub highlighted"
              [class.selected]="currentFormulaWithGroup === formulaWithGroup"
            >
              <div class="type">Bonus Fidélité dès la 2ème année</div>
            </div>
          </div>
        </ng-template>
      </mat-expansion-panel>
      <wz-pricing
        [staggering]="staggering"
        [isLoading]="isLoading || !currentFormulaWithGroup.formula.pricing"
        [selected]="currentFormulaWithGroup === formulaWithGroup"
        [pricing]="formulaWithGroup.formula.pricing"
      >
      </wz-pricing>
      <button
        type="button"
        [disabled]="readonly"
        *ngIf="formulaWithGroup !== currentFormulaWithGroup; else isSelectedFormulaTmp"
        class="select-this"
        mat-raised-button
        color="primary"
        (click)="selectFormula(formulaWithGroup)"
      >
        Choisir cette formule
      </button>
      <ng-template #isSelectedFormulaTmp>
        <div class="selected-text"><mat-icon>check</mat-icon>Formule sélectionnée</div>
      </ng-template>
    </mat-card-content>
  </mat-card>-->

  <!-- <div class="warranties">
    <div *ngFor="let f of listeReponseAfi[0].Tarifs]" class="warranty">
      {{ f.CodeFormule }}

    </div>
  </div> -->

  <!-- <div class="divOffre" *ngFor="let p of formulesAfi; let i = index">
    <div *ngFor="let f of p.tarifsTout; let index = index">
      {{ f.produitTarif + ' : ' + f.codeFormule }}
    </div>
  </div> -->
</div>
